import { render, staticRenderFns } from "./fileHistory.vue?vue&type=template&id=8a04c600&scoped=true"
import script from "./fileHistory.vue?vue&type=script&lang=js"
export * from "./fileHistory.vue?vue&type=script&lang=js"
import style0 from "./fileHistory.vue?vue&type=style&index=0&id=8a04c600&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a04c600",
  null
  
)

export default component.exports